import React from 'react';
import * as FormActions from 'app/actions/form/actions';
import { reduxForm, InjectedFormProps } from 'redux-form';
import {
  ListItem, ListItemText, Dialog,
  DialogTitle,
  DialogContentText,
  DialogContent,
} from '@material-ui/core';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FieldNames } from 'app/models/fields/names';
import { TextInput } from 'app/components/FormFields/TextInput';
import { routes } from 'app/routes/route-list';
import { autoPrequalQuestionsByName } from 'app/models/questions/auto-prequal';
import { FormName } from '@lenderful/domain';

const autoPrequalQuestions = autoPrequalQuestionsByName([
  FieldNames.homeValue,
  FieldNames.propertyUsage,
  FieldNames.propertyType,
  FieldNames.propertyZip,
]);

class DevTestPrequalCalc extends React.Component<InjectedFormProps & { [key: string]: any}, any> {
  state = {
    open: false,
    result: {},
  };

  handleClickOpen = () => {
    /* Wipe liabilities on open */
    this.props.change(FieldNames.realEstateLiabilities, []);
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { change, isEnabled } = this.props;
    return (
      <React.Fragment>
        <ListItem button onClick={this.handleClickOpen} disabled={!isEnabled}>
          <ListItemText
            primary="Prequal Value Editor"
            secondary={isEnabled ? '' : 'Must be used on auto-prequal section #113'}
          />
        </ListItem>
        <Dialog open={this.state.open} onClose={this.handleClose}>
          <DialogTitle>Auto Prequal Form Value Editor</DialogTitle>
          <DialogContent>
            <DialogContentText>
                This tool can be used to modify values for the auto prequalification rates.
                By opening this tool, any liabilities set by the mock credit pull have been
                set to zero.

                Edit the desired values here and then click outside of this box to proceed with
                the form.
            </DialogContentText>
            {autoPrequalQuestions.map((question, idx) => {
              const QuestionComponent = question.component;
              return (
                <QuestionComponent
                  key={question.id}
                  {...question}
                  change = {change}
                  valid  = {this.props.valid}
                />
              );
            })}
            <TextInput
              name       = {FieldNames.creditScore}
              label      = "Credit Score"
              isOptional = {true}
            />
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { location } = state.router;
  const isAutoPrequalRoute = location.pathname === routes.autoPrequal;
  const isPrequalCalcSection = location.hash === '#113';
  return {
    rates    : state.rates,
    isEnabled: isAutoPrequalRoute && isPrequalCalcSection,
    ...ownProps,
  };
};

const mapDispatchToProps = FormActions;

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  reduxForm({
    form                    : FormName.LONGFORM,
    destroyOnUnmount        : false,
    forceUnregisterOnUnmount: true,
  }),
)(DevTestPrequalCalc as any);
